const obj = {
    merchantInfo: '/merchant/merchantInfo/thirdLoginQiyuPlatform', //七鱼客服
}
export default obj;